import React, { Component, Fragment } from "react";
import api from "../../../services/api";

const ACOES_DISPONIVEIS = [
    "login",
    "criar_meta",
    "editar_meta",
    "excluir_meta",
    "criar_usuario",
    "editar_usuario",
    "resetar_senha_usuario",
    "desativar_usuario",
    "editar_prazo"
];

function formataData(timestamp) {
    if (!timestamp) return "";
    return new Date(timestamp).toLocaleString("pt-BR");
}

export default class Logs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            logs: [],
            carregando: true,
            erro: "",
            filtroAcao: "",
            filtroUsuario: ""
        };
    }

    componentDidMount() {
        this.carregarLogs();
    }

    carregarLogs = async () => {
        this.setState({ carregando: true, erro: "" });
        try {
            let params = new URLSearchParams();
            if (this.state.filtroAcao) params.append("acao", this.state.filtroAcao);
            if (this.state.filtroUsuario) params.append("usuario", this.state.filtroUsuario);

            let resposta = await api.get(`/admin/logs?${params.toString()}`);
            this.setState({ logs: resposta.data.logs || [], carregando: false });
        } catch (erro) {
            this.setState({ erro: "Não foi possível carregar os logs.", carregando: false });
        }
    };

    onChangeFiltroAcao = (evento) => {
        this.setState({ filtroAcao: evento.target.value });
    };

    onChangeFiltroUsuario = (evento) => {
        this.setState({ filtroUsuario: evento.target.value });
    };

    onSubmitFiltro = (evento) => {
        evento.preventDefault();
        this.carregarLogs();
    };

    render() {
        let { logs, carregando, erro } = this.state;

        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h4 className="card-title">Logs de auditoria</h4>
                                </div>
                                <div className="card-body">
                                    <form className="form-inline mb-3" onSubmit={this.onSubmitFiltro}>
                                        <select className="form-control mr-2" value={this.state.filtroAcao} onChange={this.onChangeFiltroAcao}>
                                            <option value="">Todas as ações</option>
                                            {ACOES_DISPONIVEIS.map((acao) => (
                                                <option key={acao} value={acao}>{acao}</option>
                                            ))}
                                        </select>
                                        <input
                                            type="text"
                                            className="form-control mr-2"
                                            placeholder="Usuário"
                                            value={this.state.filtroUsuario}
                                            onChange={this.onChangeFiltroUsuario}
                                        />
                                        <button className="btn btn-primary" type="submit">Filtrar</button>
                                    </form>

                                    {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
                                    {carregando ? (
                                        <p>Carregando...</p>
                                    ) : (
                                        <table className="table table-striped table-hover table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Data/hora</th>
                                                    <th>Usuário</th>
                                                    <th>Ação</th>
                                                    <th>Recurso</th>
                                                    <th>Detalhes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {logs.map((log) => (
                                                    <tr key={log._id}>
                                                        <td>{formataData(log.timestamp)}</td>
                                                        <td>{log.usernameSnapshot}</td>
                                                        <td>{log.acao}</td>
                                                        <td>{log.recurso}</td>
                                                        <td>{log.detalhes}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
